import { render, staticRenderFns } from "./game-pane.vue?vue&type=template&id=049c2b60&scoped=true"
import script from "./game-pane.vue?vue&type=script&lang=js"
export * from "./game-pane.vue?vue&type=script&lang=js"
import style0 from "./game-pane.vue?vue&type=style&index=0&id=049c2b60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c2b60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049c2b60')) {
      api.createRecord('049c2b60', component.options)
    } else {
      api.reload('049c2b60', component.options)
    }
    module.hot.accept("./game-pane.vue?vue&type=template&id=049c2b60&scoped=true", function () {
      api.rerender('049c2b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/game-pane.vue"
export default component.exports